import {createReducer, find, difference, keys, keyBy, omit, pluralize} from 'helpers';

export const relations = createReducer({}, {

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.relations);
    if (action.relations.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.relations, 'serverId'),
      }, removed);
    }
    return state;
  },

  RELATIONS_SHARE: (state, { id, context, shareType, collaborator, select, generateId }) => {
    const user = select('session.user');
    const modelType = pluralize(context, 1).replace(/activity|routine|habit/, 'task').replace('diary', 'journal');
    const { self, relations } = select('relations.collaboration', { id, context }) || {};

    const data = {}

    if (!relations) {
      //add owner
      data[match?.serverId || generateId('owner')] = {
        email: user.email,
        modelId: id,
        modelType,
        serverId: match?.serverId || generateId('owner'),
        type: 'Owner'
      }
    }

    const match = find(relations, { email: collaborator.email });
    if (match && match.type == shareType) {
      state = omit(state, match.serverId);
      if (relations.length <= 2) {
        state = omit(state, relations.map(relation => relation.serverId));
      }
    } else {
      const prefix = /Assigner/.test(match?.type) ? 'Assigner' : '';
      data[match?.serverId || generateId('object')] = {
        email: collaborator.email,
        modelId: id,
        modelType,
        serverId: match?.serverId || generateId('object'),
        type: shareType == 'AssignerShare' ? 'Owner' : prefix.concat(shareType),
      }
    }

    if (shareType == 'AssignerShare') {
      if (self) {
          data[self.serverId] = {
          ...self,
          type: 'AssignerShare'
        }
      } else if (find(data, { email: user.email })) {
        find(data, { email: user.email }).type = 'AssignerShare';
      }
    }

    return {
      ...state,
      ...data
    }
  },

  TESTING_DELETE_ALL: () => ({}),

});
